export default {"src":"/_next/static/image/public/images/ic_package_bundle.b80922c500a1813cf778344190915101.svg","height":36,"width":34};